import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const LookupSchema = z.object({
	transformLookupId: z.number().nullable().optional(),
	importTypeId: z.number(),
	lookupType: z.string().min(1, "Lookup Type is required"),
	lookupValue: z.string().min(1, "Lookup Value is required"),
	sourceValue: z.string().min(1, "Source Value is required"),
	lookupDescription: z.string().transform(val => val === "" ? null : val).nullable().optional(),
	optionalLookupValue: z.string().transform(val => val === "" ? null : val).nullable().optional(),
	optionalLookupValueB: z.string().transform(val => val === "" ? null : val).nullable().optional(),
	expired: z.boolean(),
	databaseInstanceId: z.number().nullable(),
	databaseInstanceName: z.string().transform(val => val === "" ? null : val).nullable().optional(),
});

export type Lookup = z.infer<typeof LookupSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	importTypeId: number,
	params: object,
): Promise<{ data: Lookup[]; total: number }> => {
	let queryString = '';
	if (params) {
		const paramsAsString = JSON.stringify(params)
			.replace(/:/g, '=')
			.replace(/,/g, '&')
			.replace(/[{}"]/g, '');

		const searchParams = new URLSearchParams(paramsAsString);
		if (pagination) {
			searchParams.append('pageSize', pagination.pageSize.toString());
			searchParams.append('pageIndex', pagination.pageIndex.toString());
		}

		if (sorting.length > 0) {
			searchParams.append('sortBy', sorting[0].id);
			searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
		}

		queryString = `?${searchParams.toString()}`;
	}

	const response = await fetch(
		`/admin/import-type/${importTypeId}/lookups${queryString}`,
	);

	return await response.json();
};

export const getLookupTypes = async (importTypeId: number): Promise<string[]> => {
	const response = await fetch(`/admin/import-type/${importTypeId}/lookup-types`);
	return await response.json();
};

export const add = async (lookup: Lookup): Promise<boolean> => {
    const res = await fetch(`/admin/lookups`, {
        method: 'POST',
        body: JSON.stringify(lookup),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};

export const update = async (
    lookup: Lookup,
): Promise<boolean> => {
    const res = await fetch(`/admin/lookups`, {
        method: 'PATCH',
        body: JSON.stringify(lookup),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};
